import React from "react";
import TeamDriveConnectionTest from "./TeamDriveConnectionTest";
import { downloadAndOpenFile } from "./Utilities";
import * as microsoftTeams from "@microsoft/teams-js";
import { isMobile, LoadingIndicator } from "./SharedFiles";
import { Button } from "react-bootstrap";
import { WithTranslation, withTranslation } from "react-i18next";

// share between bot and plugin somehow...
interface TdFileInfo {
    globalId: string
	name?: string,
	space?: string,
	spaceId?: number,
	path?: string,
};


export const FileOpener = withTranslation()(class extends React.Component<WithTranslation> {
    state = {
        error: '',
        opening: false,
        file: null as TdFileInfo | null,
        isMobile: null as boolean|null
    };

    componentDidMount() {
        const p = new URLSearchParams(window.location.search);
        const fileParam = p.get('file');

        if (fileParam == null) {
            this.setState({error: this.props.t('Internal error: file missing.')});
            return;
        }

        const file : TdFileInfo = JSON.parse(atob(fileParam));
        this.setState({file: file});

        microsoftTeams.app.getContext().then(context => {
            if (isMobile(context)) {
                this.setState({
                    isMobile: true
                });
            } else {
                this.setState({
                    isMobile: false,
                    opening: true
                });

                // TODO check if we have access to the space the file is in and show options to join / request an invite

                return downloadAndOpenFile({ globalId: file.globalId }).then(() => {
                    microsoftTeams.dialog.url.submit();
                }).catch(err => {
                    this.setState({error: err.message});
                }).finally(() => {
                    this.setState({opening: false});
                });
            }
        });
    }

    openFileInWebportal = () => {
        window.open(`https://webportal.teamdrive.net/fileref/${this.state.file!.globalId}`, "_blank", "noreferrer");
        microsoftTeams.dialog.url.submit();
    };

    render() {
        const t = this.props.t;

        return (<div className="file-opener">
            { this.state.isMobile === false && <TeamDriveConnectionTest/> }
            { this.state.error && (<div className="alert alert-danger">{this.state.error}</div>)}
            { this.state.opening && <LoadingIndicator>{t('Opening file...')}</LoadingIndicator>}
            { this.state.isMobile && <Button variant="primary" onClick={this.openFileInWebportal}>{t('Open file in webportal')}</Button> }
        </div>);
    }
})